import type { CiaDependencies } from '~/composables/useCia/types';
import { BLOOMREACH_COOKIE } from '~~/constants/bloomreach';
import { getFirstCookieValue } from '~~/helpers/cookies/getFirstCookieValue';
import { Logger } from '~~/helpers/logger';

export const enum CartUpdateAction {
  Add = 'add',
  Remove = 'remove',
}

type CartUpdateParams = {
  action: CartUpdateAction;
  sku: string;
  cartId?: string;
  email?: string;
  userId?: string;
};

type CartUpdateRequest = {
  locale: string;
  cookie?: string;
  action?: CartUpdateAction;
  cart_id: string;
  sku: string;
  email?: string;
  user_id?: string;
};

export default (dependencies: CiaDependencies) => {

  const { fetch, cookies, languageAndCountry } = dependencies;

  return async ({
    action,
    sku,
    email,
    cartId,
    userId,
  }: CartUpdateParams): Promise<unknown> => {

    if (import.meta.server) {

      if (import.meta.dev) {

        Logger.debug('cia|cartUpdate SSR suppressed');
      
      }

      return Promise.resolve();
    
    }

    if (!sku || !cartId) {

      return Promise.resolve();
    
    }
    const bloomreachCookieValue = getFirstCookieValue(cookies?.get(BLOOMREACH_COOKIE));

    const payload: CartUpdateRequest = {
      locale: languageAndCountry,
      cookie: bloomreachCookieValue,
      action,
      cart_id: cartId,
      sku,
    };

    if (email) {

      payload.email = email;
    
    }

    if (userId) {

      payload.user_id = userId;
    
    }

    return fetch('/cia/cart-update', {
      method: 'POST',
      body: payload,
    });
  
  };

};
